// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__3CleP","text":"style_text__3dvw0","button2":"style_button2__38BU-","text2":"style_text2__WaJMu"};